// General Javascript

var app = (function() {

    // Function to update URL param if it exists, or add if it doesn't
    function updateUrlParameter(uri, key, value) {
        // remove the hash part before operating on the uri
        var i = uri.indexOf("#");
        var hash = i === -1 ? "" : uri.substr(i);
        uri = i === -1 ? uri : uri.substr(0, i);
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf("?") !== -1 ? "&" : "?";

        if (!value) {
            // remove key-value pair if value is empty
            uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), "");
            if (uri.slice(-1) === "?") {
                uri = uri.slice(0, -1);
            }
            // replace first occurrence of & by ? if no ? is present
            if (uri.indexOf("?") === -1) uri = uri.replace(/&/, "?");
        } else if (uri.match(re)) {
            uri = uri.replace(re, "$1" + key + "=" + value + "$2");
        } else {
            uri = uri + separator + key + "=" + value;
        }
        // Remove Current subcategoryParam
        return uri + hash;
    }
    // Get url param

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split("&"),
        sParameterName,
        i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split("=");

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined
                ? true
                : sParameterName[1];
            }
        }
    };

    // Show operator packages button when a package exists

    if($("#operator-special-offers").children().length > 0) {
        $(".btn.packages-promotions").addClass("active");
    }

    // Each animate-in element
    $(".animate-in").each(function() {
        // Cache the target element
        var element = $(this);
        element.waypoint(
            function(direction) {
                // On scrolling down direction
                if (direction === "down") {
                    // Add "finished-animate-in" class, this then executes a CSS3 animation to the element
                    element.addClass("finished-animate-in");
                }
            },
            {
                // Offset 80% so the element appears before you've scrolled to it
                offset: "95%"
            }
        );
        element.waypoint(
            function(direction) {
                // On scrolling down direction
                if (direction === "down") {
                    // Add "finished-animate-in" class, this then executes a CSS3 animation to the element
                    if(element.hasClass("blog")) {
                        var thumb = element.find(".thumb-image").attr("data-bg");
                        element.find(".thumb-image").attr("style", "background-image:url(\'" + thumb + "\');")
                    } else {
                        element.css("background-image", "url(" + element.attr("data-bg") + ")")
                    }
                }
            },
            {
                // Offset 120% so the image has loaded before you scroll to it
                offset: "200%"
            }
        );
    });
    // Cta on hover

    $(".cta .btn").hover(function() {
        $(this)
            .parent()
            .parent()
            .toggleClass("hover");
    });

    // Center title if button is hidden

    $(".cta").each(function() {
        if (
            $(this)
                .find(".btn")
                .hasClass("show-on-hover")
        ) {
            $(this)
                .find("h2")
                .css("margin-top", "40px");
        }
    });
    $(document).on("click", 'a[href*=\\#]:not([href=\\#])', function(event) {
        event.preventDefault();

        $("html, body").animate(
            {
                scrollTop: $($.attr(this, "href")).offset().top
            },
            200
        );
    });
    $("#golf-package-location-select").on("change", function() {
        if($(this).val() !== "all") {
            window.location = updateUrlParameter(window.location.href, "location", $(this).val());
        } else {
            var afterParams = window.location.href.split("?")[0];
            window.location = afterParams;
        }
    });

    if(getUrlParameter("location")) {
        $("#golf-package-location-select").find("option[value='" + getUrlParameter("location") + "']").prop("selected", true)
    }

    if($(".banner").length == 0) {
        $("#main").css("padding-top", "130px");
    }

    // Create Great places drop down
    $(".cities span").each(function() {
        var location = $(this).data("location");
        var location_slug = $(this).data("location-slug");
        var option = "<option value=" + location_slug + ">" + location + "</option>"
        if($("#festivals-events-location-filter option[value='" + location_slug + "']").length == 0) {
            $("#festivals-events-location-filter").append(option);
        }
    });

    $("#festivals-events-keyword-filter").on("keydown",function search(e) {
        if(e.keyCode == 13) {
            e.preventDefault();
            var newUrl = window.location.href;
            newUrl = newUrl.split("?")[0]
            newUrl = newUrl + "?" + $(this).data("change") + "=" + $(this).val().replace(" ", "%20").replace("'","");
            window.location.href = newUrl;
        }
    });

    $(".param-change").each(function() {
        if(getUrlParameter($(this).data("change"))) {
            $(this).find("option[value='" + getUrlParameter($(this).data("change")) + "']").prop("selected", true)
        }
    })
    $(".param-change").on("change", function() {
        if($(this).val() == "all") {
            var afterParams = window.location.href.split("?")[0];
            window.location = afterParams;
        } else {
            var newUrl = window.location.href;
            newUrl = newUrl.split("?")[0]
            newUrl = newUrl + "?" + $(this).data("change") + "=" + $(this).val();
            console.log(newUrl);
            window.location.href = newUrl;
        }
    });

    // Table months

    $(".festivals-table .year-2020:first").before("<tr><td colspan='3' class='year-row'><h2>2020</h2></td></tr>");
    $(".festivals-table .year-2019:first").before("<tr><td colspan='3' class='year-row'><h2>2019</h2></td></tr>");
    $(".festivals-table .year-2018:first").before("<tr><td colspan='3' class='year-row'><h2>2018</h2></td></tr>");
    $(".festivals-table .year-2017:first").before("<tr><td colspan='3' class='year-row'><h2>2017</h2></td></tr>");
    $(".festivals-table .year-2016:first").before("<tr><td colspan='3' class='year-row'><h2>2016</h2></td></tr>");
    $(".festivals-table .year-2015:first").before("<tr><td colspan='3' class='year-row'><h2>2015</h2></td></tr>");
    $(".festivals-table .year-2014:first").before("<tr><td colspan='3' class='year-row'><h2>2014</h2></td></tr>");

    $(".festivals-table .year-2020.month-january:first").before("<tr><td colspan='3' class='month-row'><h3>January</h3></td></tr>");
    $(".festivals-table .year-2020.month-february:first").before("<tr><td colspan='3' class='month-row'><h3>February</h3></td></tr>");
    $(".festivals-table .year-2020.month-march:first").before("<tr><td colspan='3' class='month-row'><h3>March</h3></td></tr>");
    $(".festivals-table .year-2020.month-april:first").before("<tr><td colspan='3' class='month-row'><h3>April</h3></td></tr>");
    $(".festivals-table .year-2020.month-may:first").before("<tr><td colspan='3' class='month-row'><h3>May</h3></td></tr>");
    $(".festivals-table .year-2020.month-june:first").before("<tr><td colspan='3' class='month-row'><h3>June</h3></td></tr>");
    $(".festivals-table .year-2020.month-july:first").before("<tr><td colspan='3' class='month-row'><h3>July</h3></td></tr>");
    $(".festivals-table .year-2020.month-august:first").before("<tr><td colspan='3' class='month-row'><h3>August</h3></td></tr>");
    $(".festivals-table .year-2020.month-september:first").before("<tr><td colspan='3' class='month-row'><h3>September</h3></td></tr>");
    $(".festivals-table .year-2020.month-october:first").before("<tr><td colspan='3' class='month-row'><h3>October</h3></td></tr>");
    $(".festivals-table .year-2020.month-november:first").before("<tr><td colspan='3' class='month-row'><h3>November</h3></td></tr>");
    $(".festivals-table .year-2020.month-december:first").before("<tr><td colspan='3' class='month-row'><h3>December</h3></td></tr>");

    $(".festivals-table .year-2019.month-january:first").before("<tr><td colspan='3' class='month-row'><h3>January</h3></td></tr>");
    $(".festivals-table .year-2019.month-february:first").before("<tr><td colspan='3' class='month-row'><h3>February</h3></td></tr>");
    $(".festivals-table .year-2019.month-march:first").before("<tr><td colspan='3' class='month-row'><h3>March</h3></td></tr>");
    $(".festivals-table .year-2019.month-april:first").before("<tr><td colspan='3' class='month-row'><h3>April</h3></td></tr>");
    $(".festivals-table .year-2019.month-may:first").before("<tr><td colspan='3' class='month-row'><h3>May</h3></td></tr>");
    $(".festivals-table .year-2019.month-june:first").before("<tr><td colspan='3' class='month-row'><h3>June</h3></td></tr>");
    $(".festivals-table .year-2019.month-july:first").before("<tr><td colspan='3' class='month-row'><h3>July</h3></td></tr>");
    $(".festivals-table .year-2019.month-august:first").before("<tr><td colspan='3' class='month-row'><h3>August</h3></td></tr>");
    $(".festivals-table .year-2019.month-september:first").before("<tr><td colspan='3' class='month-row'><h3>September</h3></td></tr>");
    $(".festivals-table .year-2019.month-october:first").before("<tr><td colspan='3' class='month-row'><h3>October</h3></td></tr>");
    $(".festivals-table .year-2019.month-november:first").before("<tr><td colspan='3' class='month-row'><h3>November</h3></td></tr>");
    $(".festivals-table .year-2019.month-december:first").before("<tr><td colspan='3' class='month-row'><h3>December</h3></td></tr>");

    $(".festivals-table .year-2018.month-january:first").before("<tr><td colspan='3' class='month-row'><h3>January</h3></td></tr>");
    $(".festivals-table .year-2018.month-february:first").before("<tr><td colspan='3' class='month-row'><h3>February</h3></td></tr>");
    $(".festivals-table .year-2018.month-march:first").before("<tr><td colspan='3' class='month-row'><h3>March</h3></td></tr>");
    $(".festivals-table .year-2018.month-april:first").before("<tr><td colspan='3' class='month-row'><h3>April</h3></td></tr>");
    $(".festivals-table .year-2018.month-may:first").before("<tr><td colspan='3' class='month-row'><h3>May</h3></td></tr>");
    $(".festivals-table .year-2018.month-june:first").before("<tr><td colspan='3' class='month-row'><h3>June</h3></td></tr>");
    $(".festivals-table .year-2018.month-july:first").before("<tr><td colspan='3' class='month-row'><h3>July</h3></td></tr>");
    $(".festivals-table .year-2018.month-august:first").before("<tr><td colspan='3' class='month-row'><h3>August</h3></td></tr>");
    $(".festivals-table .year-2018.month-september:first").before("<tr><td colspan='3' class='month-row'><h3>September</h3></td></tr>");
    $(".festivals-table .year-2018.month-october:first").before("<tr><td colspan='3' class='month-row'><h3>October</h3></td></tr>");
    $(".festivals-table .year-2018.month-november:first").before("<tr><td colspan='3' class='month-row'><h3>November</h3></td></tr>");
    $(".festivals-table .year-2018.month-december:first").before("<tr><td colspan='3' class='month-row'><h3>December</h3></td></tr>");

    $(".festivals-table .year-2017.month-january:first").before("<tr><td colspan='3' class='month-row'><h3>January</h3></td></tr>");
    $(".festivals-table .year-2017.month-february:first").before("<tr><td colspan='3' class='month-row'><h3>February</h3></td></tr>");
    $(".festivals-table .year-2017.month-march:first").before("<tr><td colspan='3' class='month-row'><h3>March</h3></td></tr>");
    $(".festivals-table .year-2017.month-april:first").before("<tr><td colspan='3' class='month-row'><h3>April</h3></td></tr>");
    $(".festivals-table .year-2017.month-may:first").before("<tr><td colspan='3' class='month-row'><h3>May</h3></td></tr>");
    $(".festivals-table .year-2017.month-june:first").before("<tr><td colspan='3' class='month-row'><h3>June</h3></td></tr>");
    $(".festivals-table .year-2017.month-july:first").before("<tr><td colspan='3' class='month-row'><h3>July</h3></td></tr>");
    $(".festivals-table .year-2017.month-august:first").before("<tr><td colspan='3' class='month-row'><h3>August</h3></td></tr>");
    $(".festivals-table .year-2017.month-september:first").before("<tr><td colspan='3' class='month-row'><h3>September</h3></td></tr>");
    $(".festivals-table .year-2017.month-october:first").before("<tr><td colspan='3' class='month-row'><h3>October</h3></td></tr>");
    $(".festivals-table .year-2017.month-november:first").before("<tr><td colspan='3' class='month-row'><h3>November</h3></td></tr>");
    $(".festivals-table .year-2017.month-december:first").before("<tr><td colspan='3' class='month-row'><h3>December</h3></td></tr>");

    $(".festivals-table .year-2016.month-january:first").before("<tr><td colspan='3' class='month-row'><h3>January</h3></td></tr>");
    $(".festivals-table .year-2016.month-february:first").before("<tr><td colspan='3' class='month-row'><h3>February</h3></td></tr>");
    $(".festivals-table .year-2016.month-march:first").before("<tr><td colspan='3' class='month-row'><h3>March</h3></td></tr>");
    $(".festivals-table .year-2016.month-april:first").before("<tr><td colspan='3' class='month-row'><h3>April</h3></td></tr>");
    $(".festivals-table .year-2016.month-may:first").before("<tr><td colspan='3' class='month-row'><h3>May</h3></td></tr>");
    $(".festivals-table .year-2016.month-june:first").before("<tr><td colspan='3' class='month-row'><h3>June</h3></td></tr>");
    $(".festivals-table .year-2016.month-july:first").before("<tr><td colspan='3' class='month-row'><h3>July</h3></td></tr>");
    $(".festivals-table .year-2016.month-august:first").before("<tr><td colspan='3' class='month-row'><h3>August</h3></td></tr>");
    $(".festivals-table .year-2016.month-september:first").before("<tr><td colspan='3' class='month-row'><h3>September</h3></td></tr>");
    $(".festivals-table .year-2016.month-october:first").before("<tr><td colspan='3' class='month-row'><h3>October</h3></td></tr>");
    $(".festivals-table .year-2016.month-november:first").before("<tr><td colspan='3' class='month-row'><h3>November</h3></td></tr>");
    $(".festivals-table .year-2016.month-december:first").before("<tr><td colspan='3' class='month-row'><h3>December</h3></td></tr>");

    $(".festivals-table .year-2015.month-january:first").before("<tr><td colspan='3' class='month-row'><h3>January</h3></td></tr>");
    $(".festivals-table .year-2015.month-february:first").before("<tr><td colspan='3' class='month-row'><h3>February</h3></td></tr>");
    $(".festivals-table .year-2015.month-march:first").before("<tr><td colspan='3' class='month-row'><h3>March</h3></td></tr>");
    $(".festivals-table .year-2015.month-april:first").before("<tr><td colspan='3' class='month-row'><h3>April</h3></td></tr>");
    $(".festivals-table .year-2015.month-may:first").before("<tr><td colspan='3' class='month-row'><h3>May</h3></td></tr>");
    $(".festivals-table .year-2015.month-june:first").before("<tr><td colspan='3' class='month-row'><h3>June</h3></td></tr>");
    $(".festivals-table .year-2015.month-july:first").before("<tr><td colspan='3' class='month-row'><h3>July</h3></td></tr>");
    $(".festivals-table .year-2015.month-august:first").before("<tr><td colspan='3' class='month-row'><h3>August</h3></td></tr>");
    $(".festivals-table .year-2015.month-september:first").before("<tr><td colspan='3' class='month-row'><h3>September</h3></td></tr>");
    $(".festivals-table .year-2015.month-october:first").before("<tr><td colspan='3' class='month-row'><h3>October</h3></td></tr>");
    $(".festivals-table .year-2015.month-november:first").before("<tr><td colspan='3' class='month-row'><h3>November</h3></td></tr>");
    $(".festivals-table .year-2015.month-december:first").before("<tr><td colspan='3' class='month-row'><h3>December</h3></td></tr>");

    $(".festivals-table .year-2014.month-january:first").before("<tr><td colspan='3' class='month-row'><h3>January</h3></td></tr>");
    $(".festivals-table .year-2014.month-february:first").before("<tr><td colspan='3' class='month-row'><h3>February</h3></td></tr>");
    $(".festivals-table .year-2014.month-march:first").before("<tr><td colspan='3' class='month-row'><h3>March</h3></td></tr>");
    $(".festivals-table .year-2014.month-april:first").before("<tr><td colspan='3' class='month-row'><h3>April</h3></td></tr>");
    $(".festivals-table .year-2014.month-may:first").before("<tr><td colspan='3' class='month-row'><h3>May</h3></td></tr>");
    $(".festivals-table .year-2014.month-june:first").before("<tr><td colspan='3' class='month-row'><h3>June</h3></td></tr>");
    $(".festivals-table .year-2014.month-july:first").before("<tr><td colspan='3' class='month-row'><h3>July</h3></td></tr>");
    $(".festivals-table .year-2014.month-august:first").before("<tr><td colspan='3' class='month-row'><h3>August</h3></td></tr>");
    $(".festivals-table .year-2014.month-september:first").before("<tr><td colspan='3' class='month-row'><h3>September</h3></td></tr>");
    $(".festivals-table .year-2014.month-october:first").before("<tr><td colspan='3' class='month-row'><h3>October</h3></td></tr>");
    $(".festivals-table .year-2014.month-november:first").before("<tr><td colspan='3' class='month-row'><h3>November</h3></td></tr>");
    $(".festivals-table .year-2014.month-december:first").before("<tr><td colspan='3' class='month-row'><h3>December</h3></td></tr>");



})();
